import React from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';

const SwitchBase = ({
  label,
  value,
  onChange
}) => {
  return React.createElement(FormControlLabel, {
    control: React.createElement(Switch, {
      checked: value,
      color: "primary",
      onChange: onChange,
      value: value
    }),
    label: label
  });
};

export default SwitchBase;